var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('el-row',{class:_vm.$style.timeoutView,attrs:{"type":"flex","justify":"end","align":"middle"}},[_c('el-col',{class:_vm.$style.detailsContainer,attrs:{"span":24,"md":{ span: 22, offset: 1 }}},[_c('h4',[_vm._v("The page timed out while loading. "),_c('br'),_vm._v(" Are you sure you're still connected to the Internet?")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }